import style from './appView.scss';


export default function ($scope) {
    'ngInject';

    $scope.style = style;
}



// WEBPACK FOOTER //
// ./src/app/views/app/AppCtrl.js